module.exports = __webpack_public_path__ + "img/未中标@3x.78a1140f.png";